<template>
  <div class="s-setting-container">
    <div class="main-header">
      <div>Maintenance Settings</div>
      <SaveCancelSection
        v-if="adminRole === 'admin'"
        :cancel="resetPartnerConfig"
        :save="updatePartnerConfig"
        :disabled="!changeCheck"
      />
    </div>
    <Maintenance
      :interval="interval"
      :sendReminder="sendReminder"
      :custom="custom"
      :onChange="handleChange"
      :errorObj="errorObj"
    />
    <ProcessOverlay
      :show="updating"
      text="Saving"
    />
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

import Maintenance from '@shared/components/partnerSettings/Maintenance.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import SaveCancelSection from '@shared/components/setting/shared/SaveCancelSection.vue';

export default {
  name: 'MaintenanceSection',
  components: {
    Maintenance,
    ProcessOverlay,
    SaveCancelSection,
  },
  mixins: [partnerSettingsMixin],
  props: {
    partnerSettings: Object,
    update: Function,
  },
  data() {
    const {
      TUNEUP_INTERVAL = '24',
      SEND_TUNEUP_REMINDER  = 'Yes',
    } = this.partnerSettings;
    let interval = TUNEUP_INTERVAL;
    let custom = '';
    if (TUNEUP_INTERVAL
      && TUNEUP_INTERVAL !== '6'
      && TUNEUP_INTERVAL !== '12'
      && TUNEUP_INTERVAL !== '24') {
      interval = 'custom';
      custom = TUNEUP_INTERVAL;
    }
    return {
      interval,
      custom,
      errorObj: {},
      updating: false,
      sendReminder: SEND_TUNEUP_REMINDER,
    };
  },
  computed: {
    changeCheck() {
      const {
        TUNEUP_INTERVAL = '24',
        SEND_TUNEUP_REMINDER  = 'Yes',
      } = this.partnerSettings;
      let changes = false;
      if (this.interval === 'custom') {
        if (TUNEUP_INTERVAL !== this.custom) {
          changes = true;
        }
      } else if (TUNEUP_INTERVAL !== this.interval) {
        changes = true;
      } else if (SEND_TUNEUP_REMINDER !== this.sendReminder) {
        changes = true;
      }
      if (!changes) {
        this.changePartnerSettingsValue('showWarningOnExit', false);
      } else if (changes && !this.showWarningOnExit && !this.warningTab) {
        this.changePartnerSettingsValue('showWarningOnExit', true);
      }
      return changes;
    },
  },
  methods: {
    handleChange(field, value) {
      if (field === 'sendReminder') {
        this[field] = 'No';
        this.interval = '';
      } else {
        this.sendReminder = 'Yes'
        this[field] = value;
      }
    },
    resetPartnerConfig() {
      const {
        TUNEUP_INTERVAL = '24',
      } = this.partnerSettings;
      let interval = TUNEUP_INTERVAL;
      let custom = '';
      if (TUNEUP_INTERVAL
        && TUNEUP_INTERVAL !== '6'
        && TUNEUP_INTERVAL !== '12'
        && TUNEUP_INTERVAL !== '24') {
        interval = 'custom';
        custom = TUNEUP_INTERVAL;
      }
      this.interval = interval;
      this.custom = custom;
      this.errorObj = {};
    },
    async updatePartnerConfig() {
      const {
        interval,
        custom,
        sendReminder
      } = this;
      const errorObj = {};
      if (interval === 'custom') {
        if (!custom) {
          errorObj.customErr = 'Please enter months between tune-up.';
        } else if (custom < 9 || custom >= 36) {
          errorObj.customErr = 'Number must be between 9 and 36';
        }
      }
      this.errorObj = errorObj;
      if (Object.keys(errorObj).length === 0) {
        this.changePartnerSettingsValue('showWarningOnExit', false);
        this.updating = true;
        let tuneupInterval = interval;
        if (interval === 'custom') {
          tuneupInterval = custom;
        }
        await this.update({
          TUNEUP_INTERVAL: tuneupInterval,
          SEND_TUNEUP_REMINDER: sendReminder,
        });
        this.updating = false;
      }
    },
  },
};
</script>
